import { IMAGES } from "../data/content";
import { MaskedLines, Reveal } from "../components/Motion";
import Marquee from "../components/Marquee";
import { CtaBand } from "../components/Cta";

const VALUES = [
  { num: "01", title: "Curiosity first", desc: "We ask unfashionable questions before we open any software. The answer is usually in the brief nobody wrote." },
  { num: "02", title: "Craft is the strategy", desc: "Taste is not decoration. The finish on the smallest frame is what makes the biggest claim believable." },
  { num: "03", title: "Candor, always", desc: "If an idea won't work, we say so — with a better one attached. No theatre, no padding." },
  { num: "04", title: "Stay for the credits", desc: "We don't ship and vanish. Launches are beginnings; we stay close for what happens after." },
];

const STATS = [
  { value: "10+", label: "years in the craft" },
  { value: "120+", label: "projects delivered" },
  { value: "14", label: "design & film awards" },
  { value: "6", label: "cities shot in" },
];

export default function About() {
  return (
    <>
      <section className="page-hero simple" data-testid="about-hero">
        <div className="ph-content">
          <p className="crumb">Studio</p>
          <h1>
            <MaskedLines lines={[<>We make room</>, <em key="u">for the unexpected.</em>]} delay={0.2} />
          </h1>
          <p className="ph-intro">
            Oasis Business Solutions is an independent creative and media production studio — a small, senior team of directors,
            designers, producers and visual obsessives working between the digital and the physical.
          </p>
        </div>
      </section>

      <section className="about section-pad" data-testid="about-story">
        <Reveal className="about-image">
          <img src={IMAGES.studio} alt="The Oasis Business Solutions studio floor" loading="lazy" />
        </Reveal>
        <Reveal delay={0.12} className="about-copy">
          <p className="eyebrow">The story so far</p>
          <h2>
            Built frame
            <br />
            by <em>frame.</em>
          </h2>
          <p>
            We started in 2014 as two people and a borrowed camera, making films for brands nobody had heard of yet. A
            decade later the tools changed — the standard didn&apos;t. Today the studio spans film, identity, product,
            social and web, because brands don&apos;t live in one medium and neither do we.
          </p>
          <p>
            We stay deliberately small. Every project gets senior hands, direct lines and an honest opinion — the things
            big agencies promise and rarely schedule.
          </p>
          <div className="about-stat">
            <strong>
              120<span>+</span>
            </strong>
            <span>
              projects shipped,
              <br />
              zero phoned in
            </span>
          </div>
        </Reveal>
      </section>

      <Marquee items={["Curiosity", "Craft", "Candor", "Consistency"]} testid="about-marquee" />

      <section className="values section-pad" data-testid="about-values">
        <Reveal className="section-heading">
          <p className="eyebrow">How we work</p>
          <span className="section-count">01 — 04</span>
        </Reveal>
        <div className="values-grid">
          {VALUES.map((value, i) => (
            <Reveal key={value.num} delay={i * 0.07} className="value-card">
              <span>{value.num}</span>
              <h3>{value.title}</h3>
              <p>{value.desc}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="stats-section section-pad" data-testid="about-stats">
        <Reveal className="stats-band four">
          {STATS.map((stat) => (
            <div className="stat-box" key={stat.label} data-testid={`about-stat-${stat.label.replace(/\s+/g, "-")}`}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </Reveal>
      </section>

      <section className="testimonial section-pad" data-testid="about-testimonial">
        <Reveal>
          <div className="quote-mark">"</div>
          <blockquote>Small enough to care, serious enough to ship. That combination is rarer than you think.</blockquote>
          <p>— Rohan Kapoor, Founder · Pulse Athletics</p>
        </Reveal>
      </section>

      <CtaBand testid="about-cta-band" />
    </>
  );
}
